export type LearningClockAnchorInput = {
  now: number;
  externalActivity: boolean;
  representativeAnalysisRunning: boolean;
  operationalCaptureActive: boolean;
  nativeStartedAt?: string | null;
  activityStartedAt?: number;
  captureElapsedMilliseconds?: number;
};

/**
 * Restores the visible elapsed clock from main-process truth after a renderer
 * reload. A long processor-only model call may emit no progress for minutes;
 * while main still reports the analysis running, the clock must keep advancing
 * from its original startedAt rather than quietly beginning again at zero.
 */
export const learningClockAnchor = ({
  now,
  externalActivity,
  representativeAnalysisRunning,
  operationalCaptureActive,
  nativeStartedAt,
  activityStartedAt,
  captureElapsedMilliseconds,
}: LearningClockAnchorInput): number | null => {
  if (!externalActivity && !representativeAnalysisRunning && !operationalCaptureActive) return null;
  if (externalActivity || representativeAnalysisRunning) {
    const parsedNativeStart = nativeStartedAt ? Date.parse(nativeStartedAt) : Number.NaN;
    return Number.isFinite(parsedNativeStart) ? parsedNativeStart : (activityStartedAt ?? now);
  }
  return now - Math.max(0, captureElapsedMilliseconds ?? 0);
};
